import styled from 'styled-components';

export const MandatoryIcon = styled.span<{ float?: 'left' | 'right' | 'none' }>`
  color: red;
  float: ${props => props.float || 'right'};
  &:after { content: '*'; }
`;
